module.exports = __webpack_public_path__ + "images/directory/carousel/customize.526598cddbea7d73ff64.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/carousel/customize.png
// module id = 2HSN
// module chunks = 0